import Button from "../components/Button";
import { Link } from "react-router-dom";
export default function ExerciseCard({ workout }) {
  // let bgColor;
  // switch (workout.Intensity_Level) {
  //   case "Beginner":
  //     bgColor = "#1971C2";
  //     break;
  //   case "Intermediate":
  //     bgColor = "#94BF95";
  //     break;
  //   case "Expert":
  //     bgColor = "#C2255C";
  //     break;
  //   default:
  //     bgColor = "#000";

  const bgColor =
    workout.Intensity_Level === "Beginner"
      ? "#1971C2"
      : workout.Intensity_Level === "Intermediate"
      ? "#94BF95"
      : workout.Intensity_Level === "Expert"
      ? "#ffa8a8"
      : "#000";

  return (
    <Link to={`/exercise/${workout.WorkOut}`}>
      <div className=" border border-orange-opacity rounded-2xl bg-orange-opacity px-6 py-8">
        <div className="flex lg:flex-col 2xl:flex-row items-start justify-start gap-3 ">
          <span
            className={` px-4 lg:px-8 py-2 bg-[#94bf95] text-white font-bold rounded-2xl inline-block `}
          >
            {workout.Muscles}
          </span>
          <span
            className={` px-6 lg:px-8 py-2 bg-[#ff6b6b] text-white font-bold rounded-2xl inline-block `}
          >
            {workout.Intensity_Level}
          </span>
        </div>

        <div className="flex flex-col mt-6">
          <h3 className="font-bold text-lg text-center">{workout.WorkOut}</h3>
          <p className="text-center mt-4">{workout.Explaination}</p>
          <button className="mt-5 px-8 py-2 bg-dark-blue text-white font-bold rounded-2xl ">
            Learn more
          </button>
        </div>
      </div>
    </Link>
  );
}
